import React from 'react';
import { UI_NEW, setUiMode, markUiIntroSeen } from './uiMode';

// Shown on the classic sign-in pages, which have no sidebar switch: opts this browser
// into the new UI straight away (the new sign-in page has "Use the classic look" to undo).
export default function TryNewUiButton() {
  const tryNewUi = () => {
    markUiIntroSeen();
    setUiMode(UI_NEW);
  };

  return (
    <button type="button" className="lnui-try" onClick={tryNewUi}>
      Try the new LeafNet look
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M5 12h14M13 6l6 6-6 6" />
      </svg>
    </button>
  );
}
